import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store/hooks";

export function QueryParamsManager() {
    const { activePaginationLimit, activePaginationPage, activeSearchParameter, activeSortParameter, activeTags } = useAppSelector(state => state.myProxiesUserPage);

    const [queryParams, setQueryParams] = useSearchParams();

    const isFirstRender = useRef(true);
    useEffect(() => {
        setQueryParams((params) => {
            if (activeSortParameter) {
                params.set("sort", activeSortParameter)
            } else {
                params.delete("sort")
            }

            if (activeSearchParameter) {
                params.set("search", activeSearchParameter)
            } else {
                params.delete("search")
            }

            if (activePaginationLimit) {
                params.set("limit", String(activePaginationLimit))
            } else {
                params.delete("limit")
            }

            if (activePaginationPage) {
                params.set("page", String(activePaginationPage))
            } else {
                params.delete("page")
            }

            if (activeTags.length) {
                params.delete("tags")
                activeTags.forEach(tag => {
                    params.append("tags", String(tag))
                })
            } else {
                params.delete("tags")
            }

            return params
        }, {
            replace: isFirstRender.current
        })

        isFirstRender.current = false;
    }, [activePaginationLimit, activePaginationPage, activeSearchParameter, activeSortParameter, activeTags]);

    return <></>
}